import { axios } from '@/plugins/axios';
import { Region } from '@/models/region';

export class RegionService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/regions/';
  }

  async createRegion(region: Region) {
    return axios
      .post<Region>(`${this.endpoint}`, region)
      .then(({ data }) => data);
  }

  async fetchRegions() {
    return axios.get<Region[]>(`${this.endpoint}`).then(({ data }) => data);
  }

  async fetchRegion(id: number) {
    return axios.get<Region>(`${this.endpoint}${id}/`).then(({ data }) => data);
  }

  async updateRegion(region: Region) {
    return axios
      .put<Region>(`${this.endpoint}${region.id}/`, region)
      .then(({ data }) => data);
  }

  async deleteRegion(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
